import React, { PureComponent } from 'react';
import Confetti from 'react-dom-confetti';
import styled from 'styled-components';

const StyledHappiness = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 309;
  pointer-events: none;

  .Confetti {
    position: absolute !important;
  }

  .Confetti0 {
    bottom: 0;
    left: 0;
  }

  .Confetti1 {
    bottom: 0;
    right: 0;
  }
`;

class HappinessExtravaganza extends PureComponent {
  state = {
    active: 0,
  };

  componentDidMount() {
    this.timer = setInterval(() => {
      this.setState(state => ({
        active: !state.active,
      }));
    }, 800);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  render() {
    const { active } = this.state;

    const config = {
      spread: 60,
      startVelocity: 50,
      elementCount: 50,
      decay: 0.96,
    };

    return (
      <StyledHappiness>
        <Confetti className="Confetti Confetti0" active={active} config={{ angle: 45, ...config }} />
        <Confetti className="Confetti Confetti1" active={active} config={{ angle: 135, ...config }} />
      </StyledHappiness>
    );
  }
}

export default HappinessExtravaganza;



// WEBPACK FOOTER //
// ./src/components/HappinessExtravaganza.js